import axios from 'axios';
import { BASE_URL } from '../types/constants';
import type { SavedVideoIdsResponse, SavedVideoListResponse, ViewingHistoryResponse } from '../types/library.types';

/**
 * Fetch saved video identifiers for the signed-in user.
 */
export const fetchSavedVideoIds = async (token: string): Promise<SavedVideoIdsResponse> => {
    const response = await axios.get<SavedVideoIdsResponse>(`${BASE_URL}/v1/library/saved/ids`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.data;
};

/**
 * Fetch saved videos and availability metadata for the signed-in user.
 */
export const fetchSavedVideos = async (token: string): Promise<SavedVideoListResponse> => {
    const response = await axios.get<SavedVideoListResponse>(`${BASE_URL}/v1/library/saved`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.data;
};

/**
 * Fetch paged viewing history for the signed-in user.
 */
export const fetchViewingHistory = async (
    token: string,
    page: number,
    pageSize: number,
    days = 365,
    query?: string
): Promise<ViewingHistoryResponse> => {
    const response = await axios.get<ViewingHistoryResponse>(`${BASE_URL}/v1/library/history`, {
        headers: {
            'Authorization': `Bearer ${token}`
        },
        params: {
            page,
            pageSize,
            days,
            q: query?.trim() || undefined
        }
    });

    return response.data;
};

/**
 * Save a video to the signed-in user's library.
 */
export const saveVideo = async (videoId: string, token: string): Promise<void> => {
    await axios.post(`${BASE_URL}/v1/library/saved`, {
        VideoId: videoId
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

/**
 * Remove a saved video from the signed-in user's library.
 */
export const removeSavedVideo = async (videoId: string, token: string): Promise<void> => {
    await axios.delete(`${BASE_URL}/v1/library/saved/${videoId}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
